import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, FormText } from 'reactstrap';

class ModalUploadFile extends Component {
  constructor(props){
    super(props)
    this.state = {
      csv: null,
    }
  }

  handleChangeFile = (event) => {
    this.setState({
        csv: event.target.files[0]
    });
};


  render() {
    return(
      <Modal isOpen={this.props.isModalOpen} toggle={this.props.closeModal} className={'modal-warning modal-logut'}>
        <ModalHeader toggle={this.props.closeModal}>Upload File to Deactivate Inventory</ModalHeader>
        <ModalBody>
          <FormGroup>
          <Label for='exampleFile'>File</Label>
          <Input type='file' name='to_deactivate' id='to_deactivate' accept='.csv' onChange={this.handleChangeFile} />
          <FormText color='muted'>
            Upload CSV file
          </FormText>
        </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={() => this.props.onSubmit(this.state.csv)}>Upload</Button>{' '}
          <Button color='secondary' onClick={this.props.closeModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ModalUploadFile